// eslint-disable-next-line
// export const contactRegex = "^[+]{1}(?:[0-9-() /.]s?){6,15}[0-9]{1}$";
export const contactRegex = "^[0-9-() /.]{6,15}[0-9]{1}$";
export const email_regex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const AskAQuestionFormValidation = (data) => {
  let errors = {};

  if (!data?.firstName) {
    errors.firstName = "First Name is required";
  }
  if (!data?.lastName) {
    errors.lastName = "Last Name is required";
  }
  if (!data?.email) {
    errors.email = "Email is required";
  }
  if (data?.email && !new RegExp(email_regex).test(data?.email)) {
    errors.email = "Enter a valid email";
  }
  if (data?.contact) {
    if (data?.contact?.length < 6) {
      errors.contact = "Contact Number must contain atleast 6 characters";
    } else if (data?.contact?.length > 15) {
      errors.contact = "Contact Number must not exceed more than 15 characters";
    } else if (!new RegExp(contactRegex).test(data?.contact)) {
      errors.contact = "Enter a valid phone number ";
    }
  }
  if (!data?.detail) {
    errors.detail = "Message/Detail/Comment is required";
  }

  return errors;
};

export const profileValidation = (data) => {
  let errors = {};
  if (data?.firstName?.length < 3) {
    errors.firstName = "First Name must contain atleast 3 characters";
  }
  if (data?.lastName?.length < 3) {
    errors.lastName = "Last Name must contain atleast 3 characters";
  }
  if (data?.email && !new RegExp(email_regex).test(data?.email)) {
    errors.email = "Enter a valid email address";
  }
  if (data?.contact) {
    if (data?.contact?.length < 9) {
      errors.contact = "Contact Number must contain atleast 9 characters";
    } else if (data?.contact?.length > 15) {
      errors.contact = "Contact Number must not exceed more than 15 characters";
    } else if (!new RegExp(contactRegex).test(data?.contact)) {
      errors.contact =
        "Enter a valid phone number and must contain country code";
    }
  }

  return errors;
};

export const leadGenerationFormSchema = (data) => {
  let errors = {};
  if (!data?.destinationCity) {
    errors.destinationCity = "Destination City is required";
  }
  if (!data?.passengerNumber) {
    errors.passengerNumber = "Passenger Number is required";
  }
  if (data?.passengerNumber === 0) {
    errors.passengerNumber = "Passenger Number should be greater than 0";
  }
  if (!data?.date) {
    errors.date = "Date is required";
  }
  if (!data?.detail) {
    errors.detail = "Detail/Message is required";
  }
  if (!data?.contact) {
    errors.contact = "Contact Number is required";
  }
  if (data?.contact) {
    if (data?.contact?.length < 9) {
      errors.contact = "Contact Number must contain atleast 9 characters";
    } else if (data?.contact?.length > 15) {
      errors.contact = "Contact Number must not exceed more than 15 characters";
    } else if (!new RegExp(contactRegex).test(data?.contact)) {
      errors.contact =
        "Enter a valid phone number and must contain country code";
    }
  }

  return errors;
};

export const bookNowValidation = (data) => {
  let errors = {};
  if (!data?.checkIn) {
    errors.checkIn =
      "Select Departure(From) Date  from Dates & Price Section and is required";
  }
  if (!data?.checkOut) {
    errors.checkOut =
      "Select  Arrival(To) Date  from Dates & Price Section and is required";
  }
  if (!data?.guest) {
    errors.guest = "Passenger(s) is/are required";
  }
  if (!data?.departureCity) {
    errors.departureCity = "Departure City is required";
  }
  if (!data?.arrivalCity) {
    errors.arrivalCity = "Arrival City is required";
  }

  return errors;
};
export const newBookNowValidation = (data) => {
  let errors = {};
  if (!data?.checkIn) {
    errors.checkIn =
      "Select Departure(From) Date from Dates & Price Section and is required";
  }
  if (!data?.checkOut) {
    errors.checkOut =
      "Select Arrival(To) Date from Dates & Price Section and is required";
  }
  if (!data?.passengerNumber) {
    errors.passengerNumber = "Passenger(s) is/are required";
  }
  if (!data?.departureCity) {
    errors.departureCity = "Departure City is required";
  }
  if (!data?.arrivalCity) {
    errors.arrivalCity = "Arrival City is required";
  }
  if (!data?.homeDepartureCity) {
    errors.homeDepartureCity = "Home Departure City is required";
  }
  // if (!data?.detail) {
  //   errors.detail = "Details are required";
  // }
  if (!data?.contact) {
    errors.contact = "Contact information is required";
  }

  return errors;
};
export const BookNowValidationInReservation = (data) => {
  let errors = {};

  if (!data?.datesAndCities && data?.tour_uuid) {
    errors.datesAndCities = "Dates is required";
  }
  if (!data?.number_of_passengers) {
    errors.number_of_passengers = "Passenger(s) is/are required";
  }

  if (!data?.home_departure_city) {
    errors.home_departure_city = "Home Departure City/Airport is required";
  }
  // if (!data?.detail) {
  //   errors.detail = "Details are required";
  // }
  if (!data?.contact) {
    errors.contact = "Contact information is required";
  }

  return errors;
};

export const validatePrimaryTravelerData = (data) => {
  let errors = {};

  if (!data?.name_of_trip) {
    errors.name_of_trip = "Name of Trip is required";
  }

  if (!data?.full_name) {
    errors.full_name = "Full Name is required";
  }
  if (!data?.passport_number) {
    errors.passport_number = "Passport Number is required";
  }
  if (!data?.passport_expiry_date) {
    errors.passport_expiry_date = "Passport Expiry Date is required";
  }
  if (!data?.passport_issue_country) {
    errors.passport_issue_country = "Passport Issue Country is required";
  }
  if (!data?.nationality) {
    errors.nationality = "Nationality is required";
  }
  if (!data?.date_of_birth) {
    errors.date_of_birth = "Date of Birth is required";
  }
  if (!data?.full_street_address) {
    errors.full_street_address = "Full Street Address is required";
  }
  if (!data?.city) {
    errors.city = "City is required";
  }
  if (!data?.country) {
    errors.country = "Country is required";
  }
  if (!data?.province_or_state) {
    errors.province_or_state = "Province or State is required";
  }
  if (!data?.postal_code_or_zip_code) {
    errors.postal_code_or_zip_code = "Postal Code or Zip Code is required";
  }
  if (!data?.email) {
    errors.email = "Email is required";
  }
  if (!data?.phone_number) {
    errors.phone_number = "Phone Number is required";
  }
  if (!data?.emergency_contact_name) {
    errors.emergency_contact_name = "Emergency Contact Name is required";
  }
  if (!data?.emergency_contact_number) {
    errors.emergency_contact_number = "Emergency Contact Number is required";
  }
  if (!data?.emergency_contact_email) {
    errors.emergency_contact_email = "Emergency Contact Email is required";
  }
  if (!data?.food_allergies) {
    errors.food_allergies = "Food Allergies information is required";
  }
  // if (!data?.special_meal_requirements) {
  //   errors.special_meal_requirements =
  //     "Special Meal Requirements information is required";
  // }
  if (!data?.mobility_issues) {
    errors.mobility_issues = "Mobility Issues information is required";
  }

  return errors;
};

export const validateSecondaryTravelerData = (data) => {
  let errors = {};

  if (!data?.secondary_full_name) {
    errors.secondary_full_name = "Full Name is required";
  }
  if (!data?.secondary_passport_number) {
    errors.secondary_passport_number = "Passport Number is required";
  }
  if (!data?.secondary_passport_expiry_date) {
    errors.secondary_passport_expiry_date = "Passport Expiry Date is required";
  }
  if (!data?.secondary_passport_issue_country) {
    errors.secondary_passport_issue_country = "Passport Issue Country is required";
  }
  if (!data?.secondary_nationality) {
    errors.secondary_nationality = "Nationality is required";
  }
  if (!data?.secondary_date_of_birth) {
    errors.secondary_date_of_birth = "Date of Birth is required";
  }
  if (!data?.secondary_full_street_address) {
    errors.secondary_full_street_address = "Full Street Address is required";
  }
  if (!data?.secondary_city) {
    errors.secondary_city = "City is required";
  }
  if (!data?.secondary_country) {
    errors.secondary_country = "Country is required";
  }
  if (!data?.secondary_province_or_state) {
    errors.secondary_province_or_state = "Province or State is required";
  }
  if (!data?.secondary_postal_code_or_zip_code) {
    errors.secondary_postal_code_or_zip_code = "Postal Code or Zip Code is required";
  }
  if (!data?.secondary_email) {
    errors.secondary_email = "Email is required";
  }
  if (!data?.secondary_phone_number) {
    errors.secondary_phone_number = "Phone Number is required";
  }
  if (!data?.secondary_emergency_contact_name) {
    errors.secondary_emergency_contact_name = "Emergency Contact Name is required";
  }
  if (!data?.secondary_emergency_contact_number) {
    errors.secondary_emergency_contact_number = "Emergency Contact Number is required";
  }
  if (!data?.secondary_emergency_contact_email) {
    errors.secondary_emergency_contact_email = "Emergency Contact Email is required";
  }
  if (!data?.secondary_food_allergies) {
    errors.secondary_food_allergies = "Food Allergies information is required";
  }
  if (!data?.secondary_mobility_issues) {
    errors.secondary_mobility_issues = "Mobility Issues information is required";
  }

  return errors;
};

export const validateAccomodationData = (data, passengerNo) => {
  let errors = {};
  if (data?.sharing_accommodation == null && passengerNo < 2) {
    errors.sharing_accommodation = "Please select one";
  }

  if (data?.sharing_accommodation == 1 && (!data?.sharing_accommodation_with || data?.sharing_accommodation_with?.trim() === "")) {
    errors.sharing_accommodation_with = "Please provide name of person you are sharing with";
  }

  if (!data?.beds && (passengerNo > 1 || data?.sharing_accommodation == 1 )) {
    errors.beds = "Please select bed preference";
  }

  return errors;
};
export const validateTravelInsurenceData = (data) => {
  let errors = {};

  if (data?.travel_insurance == null) {
    errors.travel_insurance = "Travel Insurance information is required";
  }

  return errors;
};

export const inquireValidation = (data) => {
  let errors = {};

  if (!data?.home_departure_city) {
    errors.home_departure_city = "Home Departure City is required";
  }
  if (!data?.preferred_departure_date) {
    errors.preferred_departure_date = "Preferred Departure Date is required";
  }
  if (!data?.trip_duration) {
    errors.trip_duration = "Trip Duration is required";
  }
  if (!data?.preferred_destination) {
    errors.preferred_destination = "Preferred Destination is required";
  }
  if (!data?.number_of_passengers) {
    errors.number_of_passengers = "Number of Passengers is required";
  }
  if (!data?.first_name) {
    errors.first_name = "First Name is required";
  }
  if (!data?.last_name) {
    errors.last_name = "Last Name is required";
  }
  if (!data?.email) {
    errors.email = "Email is required";
  } else if (!isValidEmail(data.email)) {
    errors.email = "Invalid email format";
  }
  if (!data?.phone) {
    errors.phone = "Phone is required";
  }
  if (!data?.description) {
    errors.description = "Description is required";
  }

  return errors;
};
export const reviewValidation = (data) => {
  let errors = {};

  if (!data?.first_name) {
    errors.first_name = "First Name is required";
  }
  // if (!data?.last_name) {
  //   errors.last_name = "Last Name is required";
  // }
  if (!data?.email) {
    errors.email = "Email is required";
  } else if (!isValidEmail(data.email)) {
    errors.email = "Invalid email format";
  }

  if (!data?.message) {
    errors.message = "Testimonial is required";
  }

  return errors;
};

const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
